'use client';
import Slider, { Settings, CustomArrowProps } from 'react-slick';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { cn } from '@/lib/utils';

import './styles.css';
import { BlogRelatedExperience } from '@/types/Blog';
import BlogArticleExperiencesCarouselCard from './Card';

type Props = {
  lang: string;
  experiences: BlogRelatedExperience[];
};

function SampleNextArrow(props: CustomArrowProps) {
  const { className, style, onClick } = props;
  return (
    <div
      className={cn(
        'blog-fe-button blog-fe-next-button !flex items-center justify-center',
        className,
      )}
      onClick={onClick}>
      <FiChevronRight className="w-6 h-6 desktop:w-8 desktop:h-8 stroke-slate-600 opacity-30 group-hover:opacity-20 transition" />
    </div>
  );
}

function SamplePrevArrow(props: CustomArrowProps) {
  const { className, style, onClick } = props;
  return (
    <div
      className={cn(
        'blog-fe-button blog-fe-prev-button !flex items-center justify-center',
        className,
      )}
      onClick={onClick}>
      <FiChevronLeft className="w-6 h-6 desktop:w-8 desktop:h-8 stroke-slate-600 opacity-30 group-hover:opacity-20 transition" />
    </div>
  );
}

const settings: Settings = {
  dots: false,
  infinite: false,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1099,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export default function BlogArticleExperiencesCarousel({
  experiences,
  lang,
}: Props) {
  const formatedExperiences = experiences.flatMap((experience) => {
    const { experienceTranslation, macroCategory, media } = experience;

    const translation =
      experienceTranslation.find(
        (translation) => translation.locale === lang,
      ) || experienceTranslation[0];

    const macroCategoryTranslation =
      macroCategory.categoryTranslation.find(
        (translation) => translation.locale === lang,
      ) || macroCategory.categoryTranslation[0];

    const coverImage = media.filter((media) => media.type === 'cover') || [];
    return {
      translation,
      image: coverImage[0],
      macroCategoryTranslation,
    };
  });

  return (
    <div className="blog-article-experiences-carousel w-full">
      <Slider {...settings}>
        {formatedExperiences.map((experience, key) => (
          <BlogArticleExperiencesCarouselCard
            key={key}
            lang={lang}
            translation={experience.translation}
            image={experience.image}
            macroCategoryTranslation={experience.macroCategoryTranslation}
          />
        ))}
      </Slider>
    </div>
  );
}
